module.exports = __webpack_public_path__ + "img/logo.143cf43c.png";